var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 6C29 5.44772 28.5523 5 28 5H16C15.4477 5 15 5.44772 15 6C15 6.55228 15.4477 7 16 7H28C28.5523 7 29 6.55228 29 6Z",
    fill: "#26272E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 16C29 15.4477 28.5523 15 28 15H4C3.44772 15 3 15.4477 3 16C3 16.5523 3.44772 17 4 17H28C28.5523 17 29 16.5523 29 16Z",
    fill: "#26272E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 26C29 25.4477 28.5523 25 28 25H10C9.44771 25 9 25.4477 9 26C9 26.5523 9.44771 27 10 27H28C28.5523 27 29 26.5523 29 26Z",
    fill: "#26272E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIc);
export default __webpack_public_path__ + "static/media/menu_ic.aa019c1c.svg";
export { ForwardRef as ReactComponent };